// extracted by mini-css-extract-plugin
export default {"headerClient":"header-client_headerClient__AAaq9","logoProject":"header-client_logoProject__xBJbW","titleProject":"header-client_titleProject__kWC4B"};